// Lib
import { trim } from 'lodash';

// Utils
import isOnlyLink from './utils/isOnlyLink';
import { getIgnoreAutoType } from '../../../../../common/elements/utils/elementPropertyUtils';

// Constants
import { LINK_TYPE } from '../../../../../common/links/linkConstants';

export default (editorState, getProps) => {
    if (!isOnlyLink(editorState)) return false;

    const { updateElementType, preventSaveOnUnmount, element } = getProps();

    // If the element has been marked to ignore automatic type conversion, then don't trigger
    if (getIgnoreAutoType(element)) return;

    const url = trim(editorState.getCurrentContent().getPlainText());

    // Ensure the editor component doesn't force an update event now that we're
    // changing the component type
    preventSaveOnUnmount();

    const data = { temp: { url } };
    updateElementType({ elementType: LINK_TYPE, data });

    return true;
};
